module.exports = __webpack_public_path__ + "media/images/logo_wealins-7ce23b14.png";